var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"presets\":[\"es2015\",\"stage-0\"],\"plugins\":[\"transform-class-properties\",\"transform-function-bind\"]}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HumidityComponent.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-49879a5e\"}!../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HumidityComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/data/projects/nespresso/ncp-section-connected-farms/Silex/src/Resources/src/components/infos/humidity/HumidityComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HumidityComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49879a5e", Component.options)
  } else {
    hotAPI.reload("data-v-49879a5e", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/infos/humidity/HumidityComponent.vue
// module id = 786
// module chunks = 0